import { EmailSecurityAllowBlockItemType, TldOptionState } from "@/constants/phishing";
import { countriesList } from "@/constants/countries";
import { TLD_LIST } from "@/constants/tlds";

/**
 * Maps 2-char country code to readable country name from the list
 */
export const getAllowBlockListItemDisplayName = (item: {
  name: string;
  type: EmailSecurityAllowBlockItemType;
}): string =>
  item.type === EmailSecurityAllowBlockItemType.COUNTRY
    ? (countriesList[item.name?.toUpperCase()] ?? item.name)
    : item.name;

export interface TldFieldOption {
  tld: string;
  name?: string;
  state: TldOptionState;
}

const normalizeTld = (tld: string) => `.${tld.trim().toLowerCase().replace(/^\.+/, "")}`;

export const buildTldFieldOptions = ({
  restrictedTlds = [],
  existingTlds = [],
}: {
  restrictedTlds?: string[];
  existingTlds?: string[];
}): TldFieldOption[] => {
  const restricted = new Set(restrictedTlds.map(normalizeTld));
  const existing = new Set(existingTlds.map(normalizeTld));

  const getState = (tld: string) => {
    if (restricted.has(tld)) return TldOptionState.RESTRICTED;
    if (existing.has(tld)) return TldOptionState.ALREADY_ON_LIST;
    return TldOptionState.AVAILABLE;
  };

  const known = TLD_LIST.map(({ tld, name }) => ({
    tld,
    name,
    state: getState(normalizeTld(tld)),
  }));

  const knownTlds = new Set(known.map(({ tld }) => normalizeTld(tld)));
  const unknownRestricted = [...restricted]
    .filter((tld) => !knownTlds.has(tld))
    .sort()
    .map((tld) => ({ tld, state: TldOptionState.RESTRICTED }));

  return [...known, ...unknownRestricted];
};
